import { render, staticRenderFns } from "./XContextMenu.vue?vue&type=template&id=6ad7e8f1&scoped=true&"
import script from "./XContextMenu.vue?vue&type=script&lang=js&"
export * from "./XContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./XContextMenu.vue?vue&type=style&index=0&id=6ad7e8f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad7e8f1",
  null
  
)

export default component.exports